/* eslint-disable angular/factory-name */

(function iife() {
	"use strict";

	angular.module("dx.webapp.migration").factory("positionByElement", positionByElementService);

	// Position an element by another element or a group of elements.
	// If using a group of elements is used a unified bounding box for them will be created.

	// Complex shit that I'd love to "Ctrl+A > Del"...

	function positionByElementService(
		$window
	) {
		return positionByElement;

		// positionedEl = (Element) element to position.
		// anchorEl = (Element, Array of Elements) element(s) to anchor the positioned element by.
		// preferredPosition = ("before", "after") side to position the element on if there is available space.
		// offset = (Number) number of pixels between the element that is positioned and the anchor and screen edges.
		function positionByElement(positionedEl, anchorEl, preferredPosition, offset) {
			var pos = {
				left: null,
				top: null,
				target: positionedEl.getBoundingClientRect(),
				anchor: anchorEl instanceof $window.Element ? anchorEl.getBoundingClientRect() : getBoundingClientRectUnifiedFromMany(anchorEl),
				viewport: {
					width: $window.innerWidth,
					height: $window.innerHeight,
				},
				scroll: {
					top: $window.document.body.scrollTop,
					left: $window.document.body.scrollLeft,
				},
			};

			// Will most likely happen because the target is not visible yet.
			// Attach and show the target before positioning it.
			if (!(pos.target.width > 0 && pos.target.height > 0)) {
				return;
			}

			var posX = getNewPositionOnAxis(pos, "x", preferredPosition, offset);
			var posY = getNewPositionOnAxis(pos, "y", preferredPosition, offset);

			// Find first axis position
			if (posX && typeof posX.pos === "number") {
				pos.left = posX.pos;
				pos.edge = posX.edge;
			} else if (posY) {
				pos.top = posY.pos;
				pos.edge = posY.edge;
			}

			// Center on remaining axis
			if (pos.left === null && pos.top === null) {
				pos.left = pos.scroll.left + (pos.viewport.width / 2) - (pos.target.width / 2);
				pos.top = pos.scroll.top + (pos.viewport.height / 2) - (pos.target.height / 2);
			} else if (pos.left === null) {
				pos.left = getNewCenterPositionOnAxis(pos, "x", offset);
			} else if (pos.top === null) {
				pos.top = getNewCenterPositionOnAxis(pos, "y", offset);
			}

			angular.
				element(positionedEl).
				attr("position-side", pos.edge).
				css({
					top: Math.round(pos.top) || 0,
					left: Math.round(pos.left) || 0,
				});
		}

		function getBoundingClientRectUnifiedFromMany(els) {
			var rect = els[0].getBoundingClientRect();

			if (els.length === 1) {
				return rect;
			}

			// Can't use `angular.extend` because the properties of a DOMRect is non-enumerable
			// and so they will not be copied...
			var unified = {
				top: rect.top,
				bottom: rect.bottom,
				left: rect.left,
				right: rect.right,
			};

			for (var i = els.length - 1; i > 0; i--) {
				rect = els[i].getBoundingClientRect();
				unified.top = Math.min(unified.top, rect.top);
				unified.bottom = Math.max(unified.bottom, rect.bottom);
				unified.left = Math.min(unified.left, rect.left);
				unified.right = Math.max(unified.right, rect.right);
			}

			var viewportWidth = $window.innerWidth;
			var viewportHeight = $window.innerHeight;

			unified.width = viewportWidth - unified.left - (viewportWidth - unified.right);
			unified.height = viewportHeight - unified.top - (viewportHeight - unified.bottom);

			return unified;
		}

		function getNewPositionOnAxis(pos, axis, preferredPosition, offset) {
			var start = {x: "left", y: "top"}[axis];
			var end = {x: "right", y: "bottom"}[axis];
			var size = {x: "width", y: "height"}[axis];
			var axisPos;

			var hasSpaceBefore = pos.anchor[start] - offset >= pos.target[size];
			var hasSpaceAfter = pos.viewport[size] - pos.anchor[end] - offset >= pos.target[size];
			var posBefore = pos.scroll[start] + pos.anchor[start] - offset - pos.target[size];
			var posAfter = pos.scroll[start] + pos.anchor[end] + offset;

			if (preferredPosition === "before") {
				if (hasSpaceBefore) {
					axisPos = {pos: posBefore, edge: start};
				} else if (hasSpaceAfter) {
					axisPos = {pos: posAfter, edge: end};
				}
			} else if (hasSpaceAfter) {
				axisPos = {pos: posAfter, edge: end};
			} else if (hasSpaceBefore) {
				axisPos = {pos: posBefore, edge: start};
			}

			return axisPos;
		}

		function getNewCenterPositionOnAxis(pos, axis, offset) {
			var start = {x: "left", y: "top"}[axis];
			var size = {x: "width", y: "height"}[axis];
			var centerPos = pos.scroll[start] + pos.anchor[start] + (pos.anchor[size] / 2) - (pos.target[size] / 2);
			return Math.max(pos.scroll[start] + offset, Math.min(centerPos, pos.scroll[start] + pos.viewport[size] - pos.target[size] - offset));
		}
	}
}());
